// extracted by mini-css-extract-plugin
export default {"titlesListContainer":"titlesListContainer---EXsv2","cellTopAlign":"cellTopAlign---_3dT_","headerCell":"headerCell---zJrM_"};